import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../components/grid";
import { getClockItems, billingItemsClocks, clocksSummary } from "../../../store/actions";
import { format } from 'date-fns';
import ClockItem from "./clockItem";
import AddIcon from '../../../assets/images/ionic-ios-add-circle-outline.png';
class ClockItems extends Component {
  state = {
    loading: false,
    selectedRowData: "",
    isEdit: false,
    showClockDetails: false,
    billingClocks: [],
    columnDefs: [
      {
        headerName: "Item Name",
        field: "itemName",
        resizable: true,
        filter: "agTextColumnFilter",
        sortable: true,
        width: "auto",
        flex: 1
      },
      {
        headerName: "Description",
        field: "itemDescription",
        resizable: true,
        filter: "agTextColumnFilter",
        sortable: true,
        width: "auto",
        flex: 1
      },
      {
        headerName: "Purchased",
        field: "purchased",
        resizable: true,
        width: 150,
        filter: false,
        flex: 1
      },
      {
        headerName: "In stock",
        field: "available",
        resizable: true,
        filter: 'agNumberColumnFilter',
        width: 100,
        flex: 1
      },
      {
        headerName: "Sold",
        field: "sold",
        resizable: true,
        filter: false,
        width: 100

      },
      {
        headerName: "Last purchase date",
        field: "purchaseDate",
        width: 150,
        filter: false,
        valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
        flex: 1
      },
      {
        headerName: "Last outbound order date",
        field: "outBoundOrderDate",
        resizable: true,
        width: 150,
        filter: false,
        valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
        flex: 1
      },

    ],
    rowData: [],
    searchText: '',
  };

  async componentDidMount() {
    await this.props.getClockItems();
    await this.props.billingItemsClocks();
    await this.props.clocksSummary();
    this.setState({ rowData: this.props.CLOCKS_SUMMARY, billingClocks: this.props.CLOCKS_BILLING_ITEMS });
  }

  onGridReady = params => {
    params.api.addGlobalListener((type, e) => {
      if (type === "rowClicked") {
        this.EditClock(e.data);
      }
    })
    /*    this.gridApi = params.api;
       this.columnApi = params.columnApi;
       let dataSource = {
         getRows: async (params) => {
           this.usersPayload.startRow = params.startRow;
           this.usersPayload.endRow = params.endRow;
           this.usersPayload.searchText = this.state.searchText;
           // use redux..
           this.gridApi.showLoadingOverlay();
           /*  getSummeryReport().then(summeryReport => {
              this.gridApi.hideOverlay();
              if (!summeryReport.length) {
                this.gridApi.showNoRowsOverlay();
              } else {
    
                return params.successCallback(summeryReport, summeryReport.length);
              }
            });
     
   
         }
       }
       params.api.setDatasource(dataSource) */
  };

  searchInput = (e) => {
    this.setState({ searchText: e.target.value });
    this.gridApi.purgeInfiniteCache();
    // this.gridApi.refreshInfiniteCache();
  };
  /* 
    refreshGrid = () => {
      this.gridApi.refreshInfiniteCache();
    }; */

  async EditClock(event) {

    this.setState({ isEdit: true, showClockDetails: true });
    this.setState({ selectedRowData: event });
  };

  closeSidebar = () => {
    this.setState({ isEdit: false, showClockDetails: false, rowData: this.props.CLOCKS_SUMMARY });
  };

  AddClockItem = () => {
    this.setState({ showClockDetails: true });
  }

  render() {
    const { showClockDetails, isEdit, selectedRowData } = this.state;

    return (
      <>
        <div className="table-header d-flex align-items-center justify-content-between">
          <button className="add_order" onClick={this.AddClockItem}><img src={AddIcon} alt="" /> Add </button>
        </div>
        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">
            <div className="filter-field d-flex">
              <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
            </div>
          </div>
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              onGridReady={this.onGridReady}
              rowData={this.state.rowData}
              height='600px'
            >
            </Grid>
          </div>

        </div>
        {showClockDetails && (<ClockItem
          showClockDetails={showClockDetails}
          isEdit={isEdit}
          clockDetails={selectedRowData}
          closeSidebar={this.closeSidebar} />)}
      </>
    )
  }
}

const mapStateToProps = ({ InventoryItemsReducer }) => {
  let { CLOCKS_ITEMS, CLOCKS_BILLING_ITEMS, CLOCKS_SUMMARY } = InventoryItemsReducer;
  return { CLOCKS_ITEMS, CLOCKS_BILLING_ITEMS, CLOCKS_SUMMARY };
};
export default connect(mapStateToProps, { getClockItems, billingItemsClocks, clocksSummary })(ClockItems);